import handlesJson from '../../content/npcs/xclone-handles.json';

export type TribeId =
  | 'wsb'
  | 'fintwit'
  | 'cnbc'
  | 'maga'
  | 'left'
  | 'crypto'
  | 'press'
  | 'mom';

export interface XCloneHandle {
  handle: string;
  displayName: string;
  tribe: TribeId;
  posts: string[];
}

export const ALL_HANDLES: XCloneHandle[] = handlesJson as XCloneHandle[];

export const TRIBE_LABEL: Record<TribeId, string> = {
  wsb: 'r/wallstreetbets',
  fintwit: 'finance twitter',
  cnbc: 'CNBC',
  maga: 'MAGA',
  left: 'the left',
  crypto: 'crypto bros',
  press: 'press',
  mom: 'your mom',
};

export const TRIBE_COLOR: Record<TribeId, string> = {
  wsb: '#ff7b00',
  fintwit: '#6ec1ff',
  cnbc: '#ffb84d',
  maga: '#ff3030',
  left: '#4ec9b0',
  crypto: '#a855f7',
  press: '#94a3b8',
  mom: '#f0a3c8',
};
